/*
  * Copyright Mission 42 Ventures, Inc. All rights reserved.
  * Unauthorized copying, distribution, or use is prohibited.
  */

import React from 'react';
import { Box } from '@material-ui/core';
import { FilterChips } from './FilterChips';
import { useHomeScope } from './HomeScopeContext';
import { OwnedEntitiesContent } from './HomePage';

/**
 * Body-only "Services" card for the customizable grid (PLAT-384). Renders the
 * filter chips + owned-entities list without an InfoCard — the grid's card
 * extension supplies the frame + "Services" title chrome. Scope context lives
 * in the ScopeRow above the grid, so the body carries no scope heading.
 */
export const ServicesCardBody = () => {
  const {
    typeFilter,
    setTypeFilter,
    lifecycleFilter,
    setLifecycleFilter,
    typeFacets,
    lifecycleFacets,
    filteredServices,
    allEntities,
    loading,
    error,
    servicesViewAllHref,
  } = useHomeScope();

  return (
    <>
      <Box mb={1.5}>
        <FilterChips
          ariaLabel="Filter services"
          groups={[
            {
              key: 'type',
              items: typeFacets,
              value: typeFilter,
              onChange: setTypeFilter,
            },
            {
              key: 'lifecycle',
              items: lifecycleFacets,
              value: lifecycleFilter,
              onChange: setLifecycleFilter,
            },
          ]}
        />
      </Box>
      <OwnedEntitiesContent
        entities={filteredServices}
        totalUnscoped={allEntities.length}
        loading={loading}
        error={error}
        viewAllHref={servicesViewAllHref}
      />
    </>
  );
};
